// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"DV-z","inlineTitle":"EV-z","sponsoredAdsWrapper":"FV-z","marketplaceRecosWrapper":"GV-z"};